import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/production/inferior',
    name: 'POST_PRODUCTION_INFERIOR',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
